import { Button } from '@mui/material';
import React from 'react';
import { Package } from 'models';
import { useTranslation } from 'react-i18next'
import { SwedSec } from 'lib/swedsec/swedsec';
import { SnackBarContext } from 'components';


export interface ISwedSecButtonProps {
  akuPackage: Package,
  ids?: string[],
}

export const SwedSecButton = (props: ISwedSecButtonProps): JSX.Element => {
  const { akuPackage, ids } = props;
  const { t } = useTranslation();
  const { toast }   = React.useContext(SnackBarContext);

  const report = async () => {
    try {
      const reporter = new SwedSec.Report(akuPackage);
      const total = await reporter.report(ids);
      console.log({total})
      toast(`${t('toast_success_report_aku_users')} (${total})`, 'success');
    } catch(err) {
      console.error("Failed to report to SwedSec", err);
      const errorMsg = err?.message as string;
      const formattedError = errorMsg
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/^\w/, c => c.toUpperCase());
      toast(t('toast_error_report_aku_users') + " " + formattedError, 'error')
    }
  }
  
  return (
    <Button variant='contained' onClick={report} disabled={ids?.length < 1 || !ids}>
        {t('report_swedsec') }
    </Button>
  );
};